export class Manufacturer {
  private constructor(readonly id: string) {}

  static readonly h = new Manufacturer('h'); // Hama

  static readonly values = [Manufacturer.h];
}
